import { RichTextEditor } from "@gull";
import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { set } from "lodash";
import { postNotification } from "app/services/memberService";
import { NotificationManager } from "react-notifications";

const validationModel = yup.object().shape({
  notificationSubject: yup
    .string()
    .required("Notification Subject is required!"),
  notificationDescription: yup
    .string()
    .required("Notification Description is required!"),
  status: yup.boolean().required("Status is required!"),
});

const notificationItemOptions = [
  { value: "General", label: "General" },
  { value: "Promo", label: "Promo" },
  { value: "Others", label: "Others" },
];

const AddNotification = ({ loadNotification }) => {
  const [notificationDescription, setNotificationDescription] = useState("");
  const formik = useFormik({
    initialValues: {
      notificationSubject: "",
      notificationDescription: "",
      status: true,
    },
    validationSchema: validationModel,
    onSubmit: async (values) => {
      try {
        const response = await postNotification(values);
        // console.log(response);
        if (response.data.status == "Success") {
          NotificationManager.success("Notification saved successfully");
          document.querySelectorAll(".btn-close")[0].click();
          loadNotification();
          formik.values.notificationSubject = "";
          formik.values.notificationDescription = notificationDescription;
          formik.values.status = "";
        } else {
          NotificationManager.error("Something went to be wrong");
        }
      } catch (error) {
        throw error;
      }
    },
  });

  const notificationHandler = (value) => {
    setNotificationDescription(value);
    formik.setFieldValue("notificationDescription", value);
  };

  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addNewNotificationLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addNewNotificationLabel">
              Add Notification
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <form
            className="needs-validation"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <div className="modal-body">
              <Row className="mb-2">
                <Col>
                  <RenderSelectInput
                    name="notificationSubject"
                    display="Notification Type"
                    placeholder="Notification Type"
                    value={formik.values.notificationSubject}
                    error={formik.errors.notificationSubject}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.notificationSubject}
                    items={notificationItemOptions}
                    required
                  />
                </Col>
                <Col>
                  <RenderSelectInput
                    name="status"
                    display="Status"
                    placeholder="Status"
                    value={formik.values.status}
                    error={formik.errors.status}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.status}
                    required
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col>
                  <label> Notification Details :</label>
                  <RichTextEditor
                    name="notificationDescription"
                    value={notificationDescription}
                    onChange={notificationHandler}
                  />
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddNotification;
